var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1427 14.704H6.3418V29.351H12.1427V14.704Z",
    fill: "#205368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9981 14.704H15.0977V29.351H17.9981V14.704Z",
    fill: "#205368"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8985 14.704H17.998V29.351H20.8985V14.704Z",
    fill: "#205368"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6564 14.704H23.8555V29.351H29.6564V14.704Z",
    fill: "#205368"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6545 14.704V29.351H23.8536V14.704H20.8985V29.351H17.998V36H34.1456V29.351H32.6096V14.704H29.6545Z",
    fill: "#ECBF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1456 8.64819H17.998V14.704H34.1456V8.64819Z",
    fill: "#DDB401"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1456 8.64816L17.998 0V8.64816H34.1456Z",
    fill: "#ECBF00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9991 29.351H15.0986V14.704H12.1435V29.351H6.3426V14.704H3.38749V29.351H1.85156V36H17.9991V29.351Z",
    fill: "#FFCF00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9991 8.64819H1.85156V14.704H17.9991V8.64819Z",
    fill: "#ECBF00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9991 0L1.85156 8.64816H17.9991V0Z",
    fill: "#FFCF00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank);
export default __webpack_public_path__ + "static/media/Icon_bank.bf891f3d99bd7326de194c2dffe52f4b.svg";
export { ForwardRef as ReactComponent };